import { put, delay, call, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import config from '../config';
import Cookies from 'js-cookie';

//Action
import { loadingSet } from '../action/uiAction';

function* myProfileGet(action) {
  const {res, err} = yield call(function(payload) {
    const params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('item', payload.item);
    params.append('testMode', Cookies.get('TEST_MODE'));
    return axios.post(config.apiUri + "member/myProfileApi.php", params, {
      timeout: 10000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);

  if (res) {
    if (res.data.bool === true) {
      if (res.data.proof) {
        yield put({
          type: "MY_PROOF_SET",
          payload: res.data.proof,
        });
      }
      if (res.data.photo) {
        yield put({
          type: "MY_PHOTO_SET",
          payload: res.data.photo,
        });
      }
      if (res.data.personality) {
        yield put({
          type: "MY_PERSONALITY_SET",
          payload: res.data.personality,
        });
      }
      if (res.data.keyword) {
        yield put({
          type: "MY_KEYWORD_SET",
          payload: res.data.keyword,
        });
      }
      if (res.data.request) {
        yield put({
          type: "MY_REQUEST_SET",
          payload: res.data.request,
        });
      }
      if (res.data.setting) {
        yield put({
          type: "MY_SETTING_SET",
          payload: res.data.setting,
        });
      }
      if (res.data.profile) {
        yield put({
          type: "MY_PROFILE_SET",
          payload: res.data.profile,
        });
        if (window.fbq) {
          window.fbq('track', 'PageView', {eventID: 'member.'+res.data.profile.userdata_id});
        }
      }
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
}


function* myProfileUserSave(action) {
  yield put(loadingSet(true));
  const {res, err} = yield call(function(payload) {
    const user = payload.user;

    const params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('region', user.region);
    params.append('region_detail', user.region_detail);
    params.append('birthplace', user.birthplace);
    params.append('birthplace_detail', user.birthplace_detail);
    params.append('relationship', user.relationship);
    params.append('height', user.height);
    params.append('style', user.style);
    params.append('association', user.association);
    params.append('marriage', user.marriage);
    params.append('child', user.child);
    params.append('lifestyle', user.lifestyle);
    params.append('smorking', user.smorking);
    params.append('drinking', user.drinking);
    params.append('gambling', user.gambling);
    params.append('pet', user.pet);
    params.append('house', user.house);
    params.append('car', user.car);
    params.append('academic', user.academic);
    params.append('religion', user.religion);
    params.append('job', user.job);
    params.append('holiday', user.holiday);
    params.append('income', user.income);
    params.append('blood', user.blood);
    params.append('constellation', user.constellation);
    return axios.post(config.apiUri + "member/myProfileUserEditApi.php", params, {
      timeout: 10000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);

  if (res) {
    if (res.data.bool === true) {
      yield delay(600);
      yield put({
        type: "MY_PROFILE_GET",
        payload: {
    			item: ['profile'],
    		},
      });
      action.callback(res.data);
    }
    else {
      yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: res.data.comment} });
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}


function* myProfilePartnerSave(action) {
  yield put(loadingSet(true));
  const {res, err} = yield call(function(payload) {
    const partner = payload.partner;

    const params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('age_low', partner.age[0]);
    params.append('age_high', partner.age[1]);
    params.append('age_important', partner.age_important);
    params.append('region', partner.region.join(','));
    params.append('region_important', partner.region_important);
    params.append('height_low', partner.height[0]);
    params.append('height_high', partner.height[1]);
    params.append('height_important', partner.height_important);
    params.append('style', partner.style.join(','));
    params.append('style_important', partner.style_important);
    params.append('association', partner.association.join(','));
    params.append('association_important', partner.association_important);
    params.append('marriage', partner.marriage.join(','));
    params.append('marriage_important', partner.marriage_important);
    params.append('child', partner.child.join(','));
    params.append('child_important', partner.child_important);
    params.append('lifestyle', partner.lifestyle.join(','));
    params.append('lifestyle_important', partner.lifestyle_important);
    params.append('smorking', partner.smorking.join(','));
    params.append('smorking_important', partner.smorking_important);
    params.append('drinking', partner.drinking.join(','));
    params.append('drinking_important', partner.drinking_important);
    params.append('gambling', partner.gambling.join(','));
    params.append('gambling_important', partner.gambling_important);
    params.append('pet', partner.pet.join(','));
    params.append('pet_important', partner.pet_important);
    params.append('academic', partner.academic.join(','));
    params.append('academic_important', partner.academic_important);
    params.append('job', partner.job.join(','));
    params.append('job_important', partner.job_important);
    params.append('income', partner.income.join(','));
    params.append('income_important', partner.income_important);
    return axios.post(config.apiUri + "member/myProfilePartnerEditApi.php", params, {
      timeout: 10000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);

  if (res) {
    if (res.data.bool === true) {
      yield delay(600);
      yield put({
        type: "MY_PROFILE_GET",
        payload: {
    			item: ['profile'],
    		},
      });
      action.callback(res.data);
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}


function* myProfileCommentSave(action) {
  yield put(loadingSet(true));
  const {res, err} = yield call(function(payload) {
    const params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('comment', payload.comment);
    params.append('partnerComment', payload.partnerComment);
    params.append('temp', payload.temp);
    return axios.post(config.apiUri + "member/myProfileCommentEditApi.php", params, {
      timeout: 10000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);

  if (res) {
    if (res.data.bool === true) {
      yield delay(600);
      yield put({
        type: "MY_PROFILE_GET",
        payload: {
    			item: ['profile','request','setting'],
    		},
      });
      yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'success', duration: 5000, comment:'コメントを申請しました。12時間以内に申請結果をメールでお知らせします'} });
      action.callback(res.data);
    }
    else {
      yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: res.data.comment} });
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}


const saga = [
  takeLatest('MY_PROFILE_GET', myProfileGet),
  takeLatest('MY_PROFILE_USER_SAVE', myProfileUserSave),
  takeLatest('MY_PROFILE_PARTNER_SAVE', myProfilePartnerSave),
  takeLatest('MY_PROFILE_COMMENT_SAVE', myProfileCommentSave),
];

export default saga;
